import { BaseLayout, UserContextMenuItem, Notifications } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { Container } from 'react-modal-promise';
import { Outlet, useNavigate } from 'react-router';

import { useGetInboxToken } from 'notificationsApi/queries/inbox/inbox';
import { useGetSenderImageHook } from 'notificationsApi/queries/messages/messages';

export const OnboardingFrame = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const { data: inboxToken, isLoading: isInboxTokenPending } = useGetInboxToken();
    const getSenderImage = useGetSenderImageHook();

    const getUserImageUrl = async (userId: string) => {
        const senderImageModel = await getSenderImage(userId);

        return senderImageModel?.data?.imageUri ?? undefined;
    };

    return (
        <div className="flex h-screen w-full flex-col">
            <BaseLayout
                background="gray"
                className="bg-background-gray-ultra-light"
                innerClassName="p-6 h-full mx-auto max-w-[1680px] bg-background-gray-ultra-light"
                versionNumber={APP_VERSION}
            >
                <BaseLayout.HeaderItems>
                    {inboxToken?.data && (
                        <Notifications
                            apiKey={inboxToken?.data?.publicApiKey ?? undefined}
                            getUserImageUrl={getUserImageUrl}
                            isLoading={isInboxTokenPending}
                            userId={inboxToken?.data?.userIdentifier}
                            userToken={inboxToken?.data?.token}
                        />
                    )}
                    <UserContextMenuItem
                        icon="domain"
                        title={t('myRegistrations')}
                        onClick={() => navigate('/requests')}
                    />
                </BaseLayout.HeaderItems>

                <BaseLayout.Content>
                    <Container />
                    <Outlet />
                </BaseLayout.Content>
            </BaseLayout>
        </div>
    );
};
